import { render, staticRenderFns } from "./perfectInfo.vue?vue&type=template&id=df7934a6&scoped=true"
import script from "./perfectInfo.vue?vue&type=script&lang=js"
export * from "./perfectInfo.vue?vue&type=script&lang=js"
import style0 from "./perfectInfo.vue?vue&type=style&index=0&id=df7934a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7934a6",
  null
  
)

export default component.exports